






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import OdataResource from '@/modules/api/OdataResource';
import IFormField from '@/modules/form/interfaces/IFormField.d.ts';

@Component({
    name: 'OdataImagesMultiSelect',
    components: {},
})
export default class OdataImagesMultiSelect extends Vue {
    @Prop() public formField!: IFormField;
    @Prop() public resourceUrl!: string;
    private errored = false;
    private loading = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private resources: any[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private checkedOptions: any[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private resourceEndpoint: OdataResource<any> = new OdataResource<any>(
        this.resourceUrl,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
        this.onResourcesLoaded,
    );

    @Watch('checkedOptions', { immediate: true, deep: true })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onCheckedOptionsChanged(val: any[]) {
        if (val !== undefined) {
            this.formField.Value = JSON.stringify(this.checkedOptions);
        } else {
            console.error('checkedOptions is undefined.');
        }
    }

    private mounted() {
        this.resourceEndpoint.baseUrl = this.resourceUrl;
        this.resourceEndpoint.getResources('');
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onImageClicked(option: any): void {
        if (this.checkedOptions.includes(option.Name)) {
            this.checkedOptions.forEach((item, index) => {
                if (item === option.Name) {
                    this.checkedOptions.splice(index, 1);
                }
            });
        } else {
            this.checkedOptions.push(option.Name);
        }
    }

    private onError(error: object) {
        console.error(error);
        this.errored = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onResourcesLoaded(resources: any[]) {
        this.resources = resources;
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }
}
